module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-11 col-md-offset-1"
  }, [_c('back-btn')], 1)]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row content-container"
  }, [_c('div', [_c('p', [_c('span', {
    staticClass: "error"
  }, [_c('span', {
    staticClass: "dash"
  }), _c('i', [_vm._v("Erreur")])]), _c('strong', [_vm._v("404")])]), _vm._v(" "), _c('p', [_vm._v("La page demandée n’existe pas")]), _vm._v(" "), _c('p', [_vm._v("οὐκ ἔστιν ἡ σελὶς ἡ διεζητημένη")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0663cf5d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404Component.vue
// module id = 89
// module chunks = 0